import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { useRefresh } from '../context/RefreshContext';

export function useOpportunities(startDate, endDate, status) {
  const [data, setData] = useState([]);
  const [pipelines, setPipelines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { refreshCount } = useRefresh();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (status) params.status = status;

    Promise.all([
      apiClient.get('/ghl/opportunities', { params }),
      apiClient.get('/ghl/pipelines'),
    ])
      .then(([oppRes, pipRes]) => {
        if (cancelled) return;
        const opps = oppRes.data.opportunities || oppRes.data || [];
        const pipes = pipRes.data.pipelines || pipRes.data || [];
        const warnings = oppRes.data.warnings || [];
        if (warnings.length) console.warn('[useOpportunities] server warnings:', warnings);
        const pipeMap = {};
        const stageMap = {};
        pipes.forEach(p => {
          pipeMap[p.id] = p.name;
          (p.stages || []).forEach(s => { stageMap[s.id] = s.name; });
        });
        opps.forEach(o => {
          o.pipelineName = pipeMap[o.pipelineId] || 'Unknown';
          if (!o.pipelineStageName && o.pipelineStageId) {
            o.pipelineStageName = stageMap[o.pipelineStageId] || null;
          }
        });
        console.log(`[useOpportunities] loaded ${opps.length} opps across ${pipes.length} pipelines`);
        setData(opps);
        setPipelines(pipes);
      })
      .catch(err => { if (!cancelled) setError(err.response?.data?.error || 'Failed to load opportunities'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [refreshCount, startDate, endDate, status]);

  return { data, pipelines, loading, error };
}
